import React from 'react';
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { green } from '@mui/material/colors';

import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme();

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  blue: {
    color: '#fff',
    backgroundColor: green[500],
  },
}));

export default function Resultado() {
  const classes = useStyles();
  return <ThemeProvider theme={theme}>
    <React.Fragment>
      <List className={classes.root}>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
              <Avatar className={classes.blue}>
                <CheckCircleOutlineIcon />
              </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Se ha cambiado correctamente tu clave"
            secondary="Recuerda que esta clave te servirá para ingresar a todos los servicios de la Universidad San Sebastián de manera fácil y segura."
          />
        </ListItem>
      </List>
    </React.Fragment>
    </ThemeProvider>;
}